'use client';

import { useContext } from 'react';
import { Card } from '@/shared/ui/card';
import { Icon } from '@/shared/ui/icon';
import { Media } from '@/shared/ui/media';
import { ProductDetailGalleryActions } from './product-detail-gallery-actions';
import { useProductDetailGallery } from './product-detail-gallery-wrapper';
import { ProductDetailTags } from './product-detail-tags';
import './product-detail.scss';
import { ProductDetailContext } from './provider';

export const ProductDetailGalleryMainImage = () => {
    const { currentItem } = useContext(ProductDetailContext);
    const { selectedIndex } = useProductDetailGallery();
    const isPresale = false;

    const selectedImage = currentItem?.assets?.[selectedIndex]?.fullUrl;

    return (
        <Card shadow className="product-detail__gallery-main-image">
            {selectedImage ? (
                <Media
                    data={{ url: selectedImage, alt: 'Produkt' }}
                    width={374}
                    height={374}
                    className="product-detail__gallery-main-image-img"
                    data-testid="product-detail-gallery-main-image"
                    data-value={selectedImage}
                />
            ) : (
                <div
                    className="product-detail__gallery-main-image-img"
                    data-testid="product-detail-gallery-main-image-placeholder"
                />
            )}
            <ProductDetailGalleryActions variant="overlay" />
            <ProductDetailTags variant="inImage" />
            {isPresale && (
                <div className="product-detail__gallery-main-image-presale-badge">
                    <Icon name="clock" width={14} height={14} />
                    <span>Předprodej</span>
                </div>
            )}
        </Card>
    );
};
